module.exports = __webpack_public_path__ + "68c8583cd68f0b274917e67688c7be1d.jpg";